import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import {
  AuthService,
  TipoPortal,
} from '../../services/authService/auth.service';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-espaco-da-familia',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, MatIcon],
  templateUrl: './espaco-da-familia.component.html',
  styleUrl: './espaco-da-familia.component.scss'
})
export class EspacoDaFamiliaComponent {
  loginForm: FormGroup;
  mostrarSenha = false;
  erroLogin = false;
  tipoPortal: TipoPortal = 'familia';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private auth: AuthService
  ) {
    this.loginForm = this.fb.group({
      usuario: ['', Validators.required],
      senha:   ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  mudarVisibilidadeSenha(): void {
    this.mostrarSenha = !this.mostrarSenha;
  }

  login(): void {
    if (this.loginForm.invalid) return;

    const { usuario, senha } = this.loginForm.value;
    const valido = this.auth.login(this.tipoPortal, usuario, senha);

    if (valido) {
      this.erroLogin = false;
      localStorage.setItem('usuarioLogado', JSON.stringify(usuario));
      this.router.navigate(['/espaco-familia', 'dashboard']);
    } else {
      this.erroLogin = true;
    }
  }

  abrirEsqueciSenha(): void {
    console.log('Esqueceu senha');
  }

  guiaRapidoAcesso(): void {
    console.log('Guia rapido acesso');
  }
}
